const STYLE = {
  sent: ["bg-emerald-50 text-emerald-700 border-emerald-200", "sent"],
  failed: ["bg-rose-50 text-rose-700 border-rose-200", "failed"],
  skipped_no_key: ["bg-slate-100 text-slate-600 border-slate-200", "skipped"],
  skipped_test_domain: ["bg-slate-100 text-slate-600 border-slate-200", "skipped (test address)"],
  pending: ["bg-sky-50 text-sky-700 border-sky-200", "sending"],
};
const TIP = { skipped_no_key: "Email key or recipient not set", skipped_test_domain: "Reserved test domain: not sent" };

// field = "email" (admin notification) | "confirm_email" | "decision_email"
export function EmailBadge({ rec, testid, field = "email", label = "Email" }) {
  const st = rec[`${field}_status`];
  if (!st) return null;
  const [cls, word] = STYLE[st] || STYLE.pending;
  const via = rec[`${field}_provider`];
  const tip = st === "failed" ? rec[`${field}_error`] : st === "sent" ? [`id ${rec[`${field}_id`]}`, via && `via ${via}`, rec[`${field}_error`]].filter(Boolean).join(" · ") : TIP[st];
  return <span title={tip || undefined} className={`rounded-full border px-2 py-0.5 text-[10.5px] font-bold ${cls}`} data-testid={testid}>{label} {word}</span>;
}
